import React, { useCallback, useState, useEffect } from "react";
import styles from "./ActionableNotification.module.css";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Box,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  resetTaskReminders,
  clearTaskReminders,
} from "../../service/websocketNotificationsSlice";
import moment from "moment";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import getTeamMember, {
  getDescriptionWithMentionedNames,
} from "../CommonFunctions/CommonFunctions";
import {
  resetLeadById,
  resetLeadLEmiData,
  resetLeadListByContact,
  resetLeadModalState,
  resetLeadPaymentData,
  resetLeadPopupTabDatas,
} from "../../pages/app/Nurture/service/nurtureSlice";
import { checkSubDomainAccess } from "../RolePermissionAccess/RolePermissionAccess";
import { setToastNotification } from "./service/toastNotificationSlice";
import { openLeadExpandModal } from "../LeadPopup/hooks/useLeadCard";
import { useNavigate } from "react-router-dom";
import { useAuthUser } from "react-auth-kit";

function TaskReminder(props: any) {
  const { courses, setIsContentMinimized, paymentReminders, active, onClick } =
    props;
  const dispatch = useDispatch();
  const { userById } = useSelector((state: any) => state.userDetails);
  const hasLeadCardPermission = checkSubDomainAccess(
    "NURTURE_BOARD",
    "LEAD_CARD",
    userById?.rolePermission
  );
  const employees = useSelector((state: any) => state.staff.staffList);
  const auth = useAuthUser();
  const authUser = auth();

  const [expandedAccordion, setExpandedAccordion] = useState(true);
  const navigate = useNavigate();

  const { taskReminders } = useSelector(
    (state: any) => state.websocketNotifications
  );
  function getCourseName(courseId: string) {
    // Search for the course with the given courseId
    const course = courses?.find((course: any) => course.id === courseId);

    // If the course is found, return its name, otherwise return null or an appropriate default value
    return course ? course?.courseName : "-";
  }
  console.log(taskReminders);
  const ClearLeadPopupQuery = () => {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.delete("leadModal");
    queryParams.delete("leadId");
    queryParams.delete("tabOpen");
    queryParams.delete("recordPayment");
    queryParams.delete("leadInstituteId");
    queryParams.delete("leadEmail");
    queryParams.delete("leadPhone");
    queryParams.delete("leadTaskId");
    queryParams.delete("leadNoteId");
    queryParams.delete("leadPaymentId");
    queryParams.delete("taskTabOpen");

    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);
    dispatch(resetLeadListByContact());
    dispatch(resetLeadPopupTabDatas());
    dispatch(resetLeadLEmiData());
    dispatch(resetLeadPaymentData());
    dispatch(resetLeadById());
    dispatch(resetLeadModalState());
  };

  const openLeadExpand = useCallback(
    (
      instituteId: string,
      phone: string,
      email: string,
      id: string,
      taskId: string,
      taskTab: string
    ) => {
      ClearLeadPopupQuery();

      openLeadExpandModal(
        instituteId,
        phone,
        email,
        id,
        dispatch,
        "task",
        taskId,
        "INCOMPLETE"
      );

      const newTaskReminders = taskReminders?.filter(
        (item: any) => item.id !== taskId
      );
      dispatch(resetTaskReminders(newTaskReminders));
      setIsContentMinimized(true);
      setExpandedAccordion(false);
    },
    [taskReminders, ClearLeadPopupQuery]
  );

  const openDemoTaskPage = useCallback(
    (taskId: string) => {
      const newTaskReminders = taskReminders?.filter(
        (item: any) => item.id !== taskId
      );
      dispatch(resetTaskReminders(newTaskReminders));
      setExpandedAccordion(false);
      const newUrl = `/app/Tasks/DemoTaskDetails/${taskId}`;
      window.open(newUrl, "_blank");
    },
    [taskReminders]
  );

  const clearTaskReminder = (taskId: string) => {
    const newTaskReminders = taskReminders?.filter(
      (item: any) => item.id !== taskId
    );
    dispatch(resetTaskReminders(newTaskReminders));
  };

  useEffect(() => {
    if (taskReminders.length === 0 && active) {
      dispatch(resetTaskReminders([]));
    }
  }, [taskReminders, active, dispatch]);

  return (
    <div style={{ maxHeight: "calc(100% - 68.8px) ", overflowY: "auto" }}>
      <Accordion
        sx={{
          color: "#142C44",
          backgroundColor: "transparent",
          border: "none",
          boxShadow: "none",
          borderBottom: "1px solid #e9e9e9 !important",

          "&.Mui-expanded": {
            marginBottom: "0",
            marginTop: "0",
          },
          "&:before": {
            display: "none",
          },
        }}
        expanded={active}
        onChange={onClick}
      >
        <AccordionSummary
          sx={{
            color: "#142C44",
            backgroundColor: "transparent",
            fontSize: "13px",
            fontWeight: "500",
            lineHeight: "22px",
            flexDirection: "row-reverse",
            gap: "14px",
            "& .MuiAccordionSummary-content ": {
              margin: "0 !important",
            },
            "&.Mui-expanded": {
              minHeight: 42,
            },
          }}
          expandIcon={<ArrowDropDownIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          Tasks (Due in 15 min)
        </AccordionSummary>
        {taskReminders && taskReminders.length > 0 && (
          <AccordionDetails
            sx={{
              overflowY: "auto",
              // paddingBottom: "100px",
              maxHeight: "325px",
            }}
          >
            {taskReminders?.map((notification: any, index: number) => {
              if (
                notification?.message ===
                  "You have few tasks pending in the To Do stage. Please complete it soon." ||
                notification?.message ===
                  "You have few tasks pending in the In Progress stage. Please complete it soon." ||
                notification?.message ===
                  "You have few tasks pending in the Blocked stage. Please complete it soon." ||
                notification?.message ===
                  "You have a lot of tasks pending. Please complete it soon."
              ) {
                return (
                  <div
                    key={index}
                    style={{
                      borderRadius: "6px",
                      border: "1px solid #EAECF0",
                      backgroundColor: "#F5F7FB",
                      marginBottom: "9px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "16px 16px 6px",
                      }}
                    >
                      <div>
                        <div className={styles.studentName}>
                          {notification?.message ===
                          "You have a lot of tasks pending. Please complete it soon."
                            ? "Global Task Reminders"
                            : notification?.message ===
                              "You have few tasks pending in the To Do stage. Please complete it soon."
                            ? "To Do Reminders"
                            : notification?.message ===
                              "You have few tasks pending in the In Progress stage. Please complete it soon."
                            ? "In Progress Reminders"
                            : "Blocked Reminders"}
                        </div>
                      </div>
                      <Box>
                        <Button
                          sx={{
                            textTransform: "capitalize",
                            textDecoration: "underline",
                            color: "#2664DC",
                            fontSize: "13px",
                            fontWeight: "400",
                            lineHeight: "22px",
                            "&:hover": {
                              textDecoration: "underline",
                              background: "none",
                            },
                          }}
                          color="primary"
                          onClick={() => {
                            navigate(
                              `/app/Tasks?selectedUsers=${authUser?.institute?.[0]?.id}`
                            );
                            clearTaskReminder(notification?.id);
                          }}
                        >
                          View
                        </Button>
                        <Button
                          sx={{
                            textTransform: "capitalize",
                            textDecoration: "underline",
                            color: "#667085",
                            fontSize: "13px",
                            fontWeight: "400",
                            lineHeight: "22px",
                            "&:hover": {
                              textDecoration: "underline",
                              background: "none",
                            },
                          }}
                          color="primary"
                          onClick={() => clearTaskReminder(notification?.id)}
                        >
                          Clear
                        </Button>
                      </Box>
                    </div>

                    <div style={{ backgroundColor: "#FFF", padding: "16px" }}>
                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "rgb(78, 85, 99)",
                          marginBottom: "8px",
                        }}
                        className={styles.reminderDesscription}
                      >
                        {notification?.message}
                      </div>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div
                    key={index}
                    style={{
                      borderRadius: "6px",
                      border: "1px solid #EAECF0",
                      backgroundColor: "#F5F7FB",
                      marginBottom: "9px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "16px 16px 6px",
                      }}
                    >
                      <div>
                        <div className={styles.studentName}>
                          {notification?.studentName}{" "}
                        </div>
                        <div className={styles.courseName}>
                          {getCourseName(notification?.enquiryData?.courseId)}
                        </div>
                      </div>
                      <Box>
                        <Button
                          sx={{
                            textTransform: "capitalize",
                            textDecoration: "underline",
                            color: "#2664DC",
                            fontSize: "13px",
                            fontWeight: "400",
                            lineHeight: "22px",
                            "&:hover": {
                              textDecoration: "underline",
                              background: "none",
                            },
                          }}
                          color="primary"
                          onClick={() =>
                            notification?.taskType === "DEMO"
                              ? openDemoTaskPage(notification?.id)
                              : hasLeadCardPermission
                              ? openLeadExpand(
                                  notification?.instituteId,
                                  notification?.studentContact,
                                  notification?.studentEmail,
                                  notification?.enquiryId,
                                  notification?.id,
                                  "INCOMPLETE"
                                )
                              : dispatch(
                                  setToastNotification({
                                    message: String(
                                      "You do not have permission to access the lead card"
                                    ),
                                    type: "error",
                                    snackOpen: true,
                                  })
                                )
                          }
                        >
                          View
                        </Button>
                        <Button
                          sx={{
                            textTransform: "capitalize",
                            textDecoration: "underline",
                            color: "#667085",
                            fontSize: "13px",
                            fontWeight: "400",
                            lineHeight: "22px",
                            "&:hover": {
                              textDecoration: "underline",
                              background: "none",
                            },
                          }}
                          color="primary"
                          onClick={() => clearTaskReminder(notification?.id)}
                        >
                          Clear
                        </Button>
                      </Box>
                    </div>

                    <div style={{ backgroundColor: "#FFF", padding: "16px" }}>
                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "rgb(78, 85, 99)",
                          marginBottom: "8px",
                        }}
                        className={styles.reminderDesscription}
                        dangerouslySetInnerHTML={{
                          __html: getDescriptionWithMentionedNames(
                            notification?.description,
                            employees
                          ),
                        }}
                      ></div>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <div className={styles.overdueTaskAssignee}>
                          {getTeamMember(notification?.assignedToId, employees)
                            ?.firstName?.charAt(0)
                            ?.toUpperCase()}
                          {getTeamMember(notification?.assignedToId, employees)
                            ?.lastName?.charAt(0)
                            ?.toUpperCase()}
                        </div>
                        <div className={styles.taskType}>
                          {notification?.taskType?.toLowerCase()}
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "4px",
                          }}
                        >
                          <div
                            className={styles.taskStatus}
                            style={{
                              color:
                                notification?.status === "TO_DO"
                                  ? "#667085"
                                  : notification?.status === "IN_PROGRESS"
                                  ? "#2664DC"
                                  : notification?.status === "BLOCKED"
                                  ? "#EC3939"
                                  : notification?.status === "COMPLETED"
                                  ? "#23A67B"
                                  : "#2664DC",
                              background:
                                notification?.status === "TO_DO"
                                  ? "rgba(102, 112, 133, 0.10)"
                                  : notification?.status === "IN_PROGRESS"
                                  ? "rgba(38, 100, 220, 0.07)"
                                  : notification?.status === "BLOCKED"
                                  ? "rgba(236, 57, 57, 0.07)"
                                  : notification?.status === "COMPLETED"
                                  ? "rgba(35, 166, 123, 0.06)"
                                  : "rgba(35, 166, 123, 0.06)",
                            }}
                          >
                            {notification?.status
                              ?.toLowerCase()
                              .replace(/_/g, " ")}
                          </div>
                        </div>
                        <div className={styles.taskDate}>
                          <AccessTimeIcon
                            style={{
                              color: "#667085",
                              fontSize: "medium",
                              display: "flex",
                              alignItems: "center",
                            }}
                          />
                          {moment(notification?.date).format("hh:mm A")}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            })}
          </AccordionDetails>
        )}
      </Accordion>
    </div>
  );
}

export default TaskReminder;
